import Path from '@leverege/path';
import { createSelectors } from '@leverege/ui-redux';
import I18N from '@leverege/i18n';
const {
  t
} = I18N.ns('molten.dataViewers.overrides.OverridesReducer');
function getKey(path, id) {
  let sPath = path;
  if (Array.isArray(sPath)) {
    sPath = sPath.join('/');
  } else if (typeof path !== 'string') {
    return null;
  }
  if (id) {
    return `${sPath}/${id}`;
  }
  return sPath;
}

// eslint-disable-next-line default-param-last
function setOverrides(state = {}, action) {
  const {
    path,
    id,
    key,
    value
  } = action;
  const vKey = getKey(path, id);
  if (typeof vKey !== 'string') {
    // eslint-disable-next-line no-console
    console.error('Invalid path in Set Overrides Action', action);
    return state;
  }
  if (id) {
    if (key) {
      // set a key in the current value. get current an copy it with changes
      const cValue = state[vKey] || {};
      const nValue = Path.copy(key, cValue, value);
      return {
        ...state,
        [vKey]: nValue
      };
    }
    return {
      ...state,
      [vKey]: value
    };
  }
  // eslint-disable-next-line no-console
  console.error('Invalid Set Overrides Action - No Id', action);
  return state;
}

// eslint-disable-next-line default-param-last
function setAllOverrides(state = {}, action) {
  return action.values;
}

// eslint-disable-next-line default-param-last
function overrides(state = {}, action) {
  if (action.type === 'molten.dataViewers.SetOverrides') {
    return setOverrides(state, action);
  }
  if (action.type === 'molten.dataViewers.SetAllOverrides') {
    return setAllOverrides(state, action);
  }
  return state;
}
const selectors = createSelectors('overrides', {
  get,
  getAll
}, true);
function createDynamicReducer() {
  return {
    id: 'molten.dataViewer.OverridesReducer',
    type: 'OverridesReducer',
    name: t('name'),
    preferredKey: 'overrides',
    reducer: overrides,
    result: selectors.setStateKey
  };
}
function getAll(state) {
  return state;
}
function get(state, path, id, key) {
  const vKey = getKey(path, id);
  const value = state[vKey];
  if (key) {
    return Path.get(key, value);
  }
  return value;
}
overrides.createDynamicReducer = createDynamicReducer;
overrides.get = selectors.get;
overrides.getAll = selectors.getAll;
overrides.getOverrides = get;
overrides.setOverrides = setOverrides;
overrides.setAllOverrides = setAllOverrides;
export default overrides;